<template>
  <div class="container competitionIndex">
    <div class="header">
      <img src="../../../assets/images/aviation_banner.jpg" alt="">
    </div>
    <div class="content">
      <van-tabs class="mainTab challenges" v-model="active" swipeable @change="tabChange" @disabled="onClickDisabled">
        <van-tab name="首页" title="首页" class="hasBG aviation two_tab_content index_tab_content">
          <van-tabs v-model="indexActive" class="secTab challenges" type="card">
            <van-tab title="活动简介">
              <div class="activity_info">
                <div class="activity_content" v-html="indexData.summary"></div>
              </div>
            </van-tab>
            <van-tab title="活动规则">
              <div class="activity_info">
                <div class="activity_content" v-html="indexData.rule"></div>
              </div>
            </van-tab>
            <van-tab title="活动奖项">
              <div class="activity_info">
                <div class="activity_content" v-html="indexData.drawinfo"></div>
              </div>
            </van-tab>
          </van-tabs>
          <div class="btn_group challenges">
            <van-button :disabled="offHours !== ''" @click="$router.push({path: '/aviation/practice', query: {id: id}})">学习</van-button>
            <van-button :disabled="offHours !== ''" @click="startExam">开始答题</van-button>
          </div>
        </van-tab>
        <van-tab name="答题" title="答题" :disabled="status === 2 || offHours !== ''" class="hasBG aviation">
          <div class="userinfo">
            <h4>信息登记</h4>
            <van-form :show-error-message="false" @submit="onSubmit">
              <van-field
                v-model="name"
                name="name"
                label="姓名："
                placeholder="请输入姓名"
                :rules="[{ required: true, message: '请输入姓名' }]"
              />
              <van-field
                readonly
                v-model="address"
                name="address"
                label="参赛地区："
                placeholder="请选择参赛地区"
                :rules="[{ required: true, message: '请选择参赛地区' }]"
                @click="showArea = true"
              >
                <template #right-icon>
                  <i class="iconfont iconxiala"></i>
                </template>
              </van-field>
              <van-field
                v-model="phonenum"
                name="phonenum"
                label="手机："
                placeholder="请输入手机号码"
                :rules="[{ required: true, message: '请输入手机号码' }]"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaData"
                  @confirm="onConfirm"
                  @cancel="showArea = false"
                />
              </van-popup>
              <div class="footer challenges">
                <van-button round block type="info" native-type="submit">开始答题</van-button>
                <p>提示：注册信息严格保密，仅作数据统计。</p>
                <p>技术支持：广东科技报   广州市乾润信息技术有限公司</p>
              </div>
            </van-form>
          </div>
        </van-tab>
        <van-tab name="成绩单" title="成绩单" :disabled="status === 1 || !isrecord || offHours !== ''" ref="transcript" class="hasBG aviation">
          <div class="transcript" v-if="transcriptReady" v-show="!showAnswer">
            <div class="transcript_box">
              <div class="transcript_form challenges">
                <h4>{{transcriptData.realname}}</h4>
                <div class="transcript_list score">
                  <span>累计用时：{{transcriptData.totaltimes}}秒</span>
                  <span>累计总分：{{transcriptData.totalscore}}分</span>
                </div>
                <div class="transcript_list">参赛地区：{{transcriptData.city}}</div>
                <div class="transcript_list">答题次数：不限次</div>
                <div class="transcript_list">本次成绩：{{transcriptData.thistimescore}}分</div>
              </div>
              <div class="transcript_img">
                <img src="../../../assets/images/cjd.png" alt="">
              </div>
            </div>
            <div class="btn-group">
              <div class="btn-group-list">
                <van-button class="deepgreen" @click="seeAnswer">答案与解析</van-button>
                <van-button class="yellowgreen" @click="active = '排行榜'">查看排行榜</van-button>
              </div>
              <div class="btn-group-list">
                <van-button class="yellowgreen" @click="showShare = true">分享到朋友圈</van-button>
                <van-button class="yellowgreen" @click="startExam">再答一次</van-button>
              </div>
              <div class="btn-group-list">
                <van-button class="deepgreen" @click="$router.push({path:'/aviation/lucklottery', query: {id: id}})">抽奖</van-button>
                <van-button class="deepgreen" @click="$router.push({path:'/aviation/winningrecord', query: {id: id}})">中奖记录</van-button>
              </div>
              <p>提示：注册信息严格保密，仅作数据统计。</p>
              <p>技术支持：广东科技报   广州市乾润信息技术有限公司</p>
            </div>
          </div>
          <div class="answer" v-if="transcriptReady" v-show="showAnswer">
            <div class="answer_list" v-for="(resultAnswer, index) in transcriptData.examResultAnswer" :key="resultAnswer.id">
              <p class="answer_index">第{{index + 1}}题：</p>
              <p class="answer_title">{{resultAnswer.examquestionname}}</p>
              <div class="answer_option">
                <div class="option_list" v-for="(examquestion, examquestionindex) in resultAnswer.examquestionselector" :key="examquestionindex">
                  <span>{{examquestion.selectorname}}、</span>
                  <p>{{examquestion.content}}<span v-if="resultAnswer.answerselector.indexOf(examquestion.selectorname) > -1">（我的选择）</span></p>
                </div>
              </div>
              <div class="rightAnswer">
                <p class="right" v-show="resultAnswer.isright === 1">正确答案：{{resultAnswer.rightanswer}}<span></span>恭喜您答对了！</p>
                <p class="error" v-show="resultAnswer.isright === 0">正确答案：{{resultAnswer.rightanswer}}<span></span>您的选择：{{resultAnswer.answerselector}}，再接再厉！</p>
              </div>
            </div>
            <div class="back">
              <van-button @click="closeAnswer">返回成绩单</van-button>
            </div>
            <p class="tips">技术支持：广东科技报   广州市乾润信息技术有限公司</p>
          </div>
          <div class="loading" v-if="!transcriptReady">
            <van-loading type="spinner" color="#1989fa" size="50px" />
          </div>
        </van-tab>
        <van-tab name="排行榜" title="排行榜" class="two_tab_content ranking_tab_content hasBG aviation">
          <van-tabs v-model="rankingActive" class="secTab challenges rankingTab" type="card" v-if="rankingReady">
            <van-tab title="个人排行">
              <div class="rankingTr personal_rankingTr">
                <div class="ranking_tr">
                  <span>名次</span>
                  <span>姓名</span>
                  <span>地区</span>
                  <span>累计成绩</span>
                  <span>累计用时(秒)</span>
                </div>
              </div>
              <div class="rankingTD">
                <div class="activity_info ranking_table personal_ranking">
                  <div class="table_wrapper">
                    <div class="ranking_td" v-for="(memberRanking, memberRankingIndex) in rankingData.memberRankingList" :key="memberRankingIndex">
                      <span>{{memberRankingIndex + 1}}</span>
                      <span>{{memberRanking.realname}}</span>
                      <span>{{memberRanking.city}}</span>
                      <span>{{memberRanking.totalscore}}</span>
                      <span>{{memberRanking.totaltimes}}</span>
                    </div>
                  </div>
                  <div class="tips_wrapper">
                    <p class="tips">提示：注册信息严格保密，仅作数据统计。</p>
                    <p class="tips">技术支持：广东科技报   广州市乾润信息技术有限公司</p>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="地区排行">
              <div class="rankingTr area_rankingTr">
                <div class="ranking_tr">
                  <span>名次</span>
                  <span>地区</span>
                  <span>总分</span>
                  <span>人数</span>
                </div>
              </div>
              <div class="rankingTD">
                <div class="activity_info ranking_table area_ranking">
                  <div class="table_wrapper">
                    <div class="ranking_td" v-for="(cityRanking, cityRankingIndex) in rankingData.cityRankingList" :key="cityRankingIndex">
                      <span>{{cityRankingIndex + 1}}</span>
                      <span>{{cityRanking.city}}</span>
                      <span>{{cityRanking.totalscore}}</span>
                      <span>{{cityRanking.membernum}}</span>
                    </div>
                  </div>
                  <div class="tips_wrapper">
                    <p class="tips">提示：注册信息严格保密，仅作数据统计。</p>
                    <p class="tips">技术支持：广东科技报   广州市乾润信息技术有限公司</p>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
          <p class="num_tip" v-if="rankingReady">地区：{{rankingData.citynum}}个，人次：{{rankingData.membernum}}次</p>
          <div class="loading" v-if="!rankingReady">
            <van-loading type="spinner" color="#1989fa" size="50px" />
          </div>
        </van-tab>
      </van-tabs>
    </div>
<!--     <div class="adv" @click="hrefTo">
      <img src="../../../assets/images/fuchuang.gif" alt="">
    </div> -->
    <van-overlay :show="showShare" @click="showShare = false">
      <div class="shareWrapper">
        <img src="../../../assets/images/share.png" alt="">
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import API from '../../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  export default {
    name: 'aviation',
    data () {
      return {
        id: '',
        status: '',
        isrecord: true,
        transcriptReady: false,
        rankingReady: false,
        showShare: false,
        active: '首页',
        indexActive: 0,
        rankingActive: 0,
        showArea: false,
        indexData: {
          summary: '',
          rule: '',
          drawinfo: ''
        },
        transcriptData: {},
        rankingData: {
          memberRankingList: [],
          cityRankingList: [],
          citynum: '',
          membernum: ''
        },
        areaData: ['广州市', '深圳市', '佛山市', '东莞市', '中山市', '珠海市', '江门市', '肇庆市', '惠州市', '汕头市', '潮州市', '揭阳市', '汕尾市', '湛江市', '茂名市', '阳江市', '云浮市', '韶关市', '清远市', '梅州市', '河源市', '广东省外'],
        name: '',
        address: '',
        phonenum: '',
        showAnswer: false,
        offHours: ''
      }
    },
    created () {
      this.$toast.allowMultiple()
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true,
        tipsMore: true
      })
      if (this.$store.state.competitionID.id) {
        if (this.$store.state.competitionID.id === 'tab') {
          this.active = '答题'
          this.$store.commit('deletecompetitionid')
        } else {
          this.active = '成绩单'
          this.$fetch.get(API.AVIATIONEXAMRESULT, {
            examid: this.$store.state.competitionID.id
          }).then(response => {
            // console.log(response)
            if (response.status !== 200) {
              var message = response.message ? response.message : '成绩单获取失败，请刷新！'
              this.$toast.fail(message)
              return
            }
            this.transcriptReady = true
            this.transcriptData = response.data
            var _this = this
            // console.log(this.$store.state.competitionID.isdraw)
            if (this.$store.state.competitionID.isdraw) {
              this.$dialog.alert({
                message: '你很棒！恭喜你获得一次抽奖机会。',
              }).then(() => {
                _this.$store.commit('deletecompetitionid')
              })
            } else {
              this.$dialog.alert({
                message: '你很棒，请再接再励。',
              }).then(() => {
                _this.$store.commit('deletecompetitionid')
              })
            }
          }).catch(error => {
            console.log(error)
          })
        }
      }
      this.$fetch.get(API.AVIATIONGETEXAM).then(response => {
        console.log(response)
        if (response.status !== 200) {
          var message = response.message ? response.message : '竞赛详情获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        document.title = response.data.examname
        this.id = response.data.id
        this.status = response.data.status
        this.isrecord = response.data.isrecord

        var start = response.data.starttime.replace(/-/g, '/')
        var end = response.data.endtime.replace(/-/g, '/')
        // console.log(new Date(end).getTime() > new Date().getTime())
        if (new Date(start).getTime() > new Date().getTime()) {
          this.offHours = 'start'
          this.$toast({
            message: '竞赛尚未开始！',
            duration: 6000
          })
        }
        if (new Date(end).getTime() < new Date().getTime()) {
          this.offHours = 'end'
          this.$toast({
            message: '很抱歉~~竞赛已经结束！',
            duration: 6000
          })
        }

        if (this.$route.query.tab && response.data.status !== 1 && response.data.isrecord && this.offHours === '') {
          this.active = '成绩单'
          this.$fetch.get(API.AVIATIONEXAMRESULT, {
            examid: this.id
          }).then(examRes => {
            // console.log(examRes)
            if (examRes.status !== 200) {
              var exammessage = examRes.message ? examRes.message : '成绩单获取失败，请刷新！'
              this.$toast.fail(exammessage)
              return
            }
            this.transcriptReady = true
            this.transcriptData = examRes.data
          }).catch(examErr => {
            console.log(examErr)
          })
        }

        this.$set(this.indexData,"summary", response.data.summary)
        this.$set(this.indexData,"rule", response.data.rule)
        this.$set(this.indexData,"drawinfo", response.data.drawinfo)
        load.clear()
        var _this = this
        if (u.indexOf('MicroMessenger') > -1) {
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
          var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          let url=''
          if (isAndroid) {
            url=location.href
          }
          if (isIOS) {
            url=location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
          }
          this.$fetch.get(API.GETWECHATINVOKESIGN, {
            url: url
          }).then(res => {
            let data = res.data
            wx.config({
              debug: false,
              appId: data.appId, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名，见附录1
              jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'onMenuShareWeibo', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
            wx.ready(function(){
              wx.onMenuShareTimeline({
                title: '航空科普知识挑战赛等你来参加', // 分享标题
                link: window.location.origin + window.location.pathname + '#/aviation/index', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png', // 分享图标
                success: function () {
                  // alert('分享了')
                  setTimeout(function(){
                    _this.share()
                  }, 600)
                }
              })
              wx.updateAppMessageShareData({
                title: '航空科普知识挑战赛等你来参加',
                desc: '让你了解更多的航空科普知识，激发探究航空航天的兴趣。',
                link: window.location.origin + window.location.pathname + '#/aviation/index',
                imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png',
                success: function() {
                  console.log('分享成功')
                }
              })
              // wx.updateTimelineShareData({
              //   title: '航空科普知识挑战赛等你来参加',
              //   link: window.location.href,
              //   imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png',
              //   success: function() {
              //     console.log('分享成功')
              //   }
              // })
              wx.onMenuShareWeibo({
                title: '航空科普知识挑战赛等你来参加',
                desc: '让你了解更多的航空科普知识，激发探究航空航天的兴趣。',
                link: window.location.origin + window.location.pathname + '#/aviation/index',
                imgUrl: 'https://ms.gdkjb.com/resources/images/logo/aviation_share_logo.png',
                success: function() {
                  console.log('分享成功')
                },
                cancel: function(){
                  console.log('分享取消')
                }
              })
            })
          })
        }
      }).catch(error => {
        console.log(error)
        load.clear()
      })
    },
    methods: {
      startExam () {
        var _this = this
        if (this.status === 1) {
          this.$dialog.alert({
            message: '请先登记信息再进行答题'
          }).then(() => {
            _this.active = '答题'
          })
        } else if (this.status === 2) {
          this.$toast('今日答题次数已用完，明天再来吧')
        } else {
          this.$router.push({
            path: '/aviation/exam',
            query: {
              id: this.id
            }
          })
        }
      },
      tabChange (name, title) {
        console.log(name)
        if (title === '排行榜' && !this.rankingReady) {
          this.$fetch.get(API.AVIATIONMEMBERRANKINGLIST, {
            examid: this.id
          }).then(response => {
            // console.log(response)
            if (response.status !== 200) {
              var message = response.message ? response.message : '排行榜获取失败，请刷新！'
              this.$toast.fail(message)
              return
            }
            this.rankingReady = true
            this.$set(this.rankingData,"cityRankingList", response.data.cityRankingList)
            this.$set(this.rankingData,"memberRankingList", response.data.memberRankingList)
            this.$set(this.rankingData,"citynum", response.data.citynum)
            this.$set(this.rankingData,"membernum", response.data.membernum)
          }).catch(error => {
            console.log(error)
          })
        } else if (title === '成绩单' && !this.transcriptReady) {
          this.$fetch.get(API.AVIATIONEXAMRESULT, {
            examid: this.id
          }).then(response => {
            // console.log(response)
            if (response.status !== 200) {
              var message = response.message ? response.message : '成绩单获取失败，请刷新！'
              this.$toast.fail(message)
              return
            }
            this.transcriptReady = true
            if (!this.$route.query.tab) {
              this.$router.replace({
                path: '/aviation/index',
                query: {tab: '3'}
              })
            }
            this.transcriptData = response.data
          }).catch(error => {
            console.log(error)
          })
        } else if (title === '答题' && this.status === 0) {
          this.$router.push({
            path: '/aviation/exam',
            query: {
              id: this.id
            }
          })
        } else if (title === '成绩单') {
          if (!this.$route.query.tab) {
            this.$router.replace({
              path: '/aviation/index',
              query: {tab: '3'}
            })
          }
        }
        if (this.$route.query.tab && title !== '成绩单' && title!== '答题') {
          this.$router.replace({
            path: '/aviation/index'
          })
        }

        this.showAnswer = false
      },
      // onClickTab (name, title) {
      //   if (title === '答题' && this.status === 0) {
      //     this.$router.push({
      //       path: '/aviation/exam',
      //       query: {
      //         id: this.id
      //       }
      //     })
      //   } else if (title === '答题' && this.status === 2) {
      //     this.$toast('今日答题次数已用完，明天再来吧')
      //     this.active = '成绩单'
      //   }
      // },
      onClickDisabled (name, title) {
        if (this.offHours === 'start') {
          this.$toast({
            message: '竞赛尚未开始！'
          })
        } else if (this.offHours === 'end') {
          this.$toast({
            message: '很抱歉~~竞赛已经结束！'
          })
        } else if (title === '成绩单') {
          if (this.status === 1) {
            this.$toast({
              className: 'competition',
              message: '请先登记信息再进行答题'
            })
            this.active = '答题'
          } else if (!this.isrecord) {
            var _this = this
            this.$dialog.alert({
              message: '请先完成答题',
            }).then(() => {
              _this.$router.push({
                path: '/aviation/exam',
                query: {
                  id: _this.id
                }
              })
            })
          }
        } else {
          this.$toast('今日答题次数已用完，明天再来吧')
        }
        // this.active = 2
      },
      onConfirm (val) {
        this.address = val
        this.showArea = false
      },
      onSubmit () {
        if (!/^1[2|3|4|5|6|7|8|9][0-9]{9}$/.test(this.phonenum)) {
          this.$toast.fail('手机号不正确')
          return
        }
        const loading = this.$toast({
          type: 'loading',
          duration: 0,
          loadingType: 'spinner',
          forbidClick: true
        })
        this.$fetch.post(API.AVIATIONADDEXAMMEMBER, {
          examid: this.id,
          phonenum: this.phonenum,
          name: this.name,
          city: this.address
        }).then(res => {
          // console.log(res)
          loading.clear();
          if (res.status !== 200) {
            this.$toast.fail(res.message ? res.message : '用户登记失败，请重新提交！')
            return
          }
          var _this = this
          this.$toast.success({
            duration: 1500,
            message: '用户登记信息成功!',
            onClose: function(){
              _this.$router.push({
                path: '/aviation/exam',
                query: {
                  id: _this.id
                }
              })
            }
          })
        })
      },
      seeAnswer () {
        this.$refs.transcript.$el.scrollTop = 0
        this.showAnswer = true
      },
      closeAnswer () {
        this.$refs.transcript.$el.scrollTop = 0
        this.showAnswer = false
      },
      share () {
        this.$fetch.get(API.AVIATIONINDEXSHARE, {
          examid: this.id
        }).then(shareres => {
          console.log('分享成功')
        }).catch(shareerr => {
          console.log(shareerr)
        })
      },
      hrefTo () {
        location.href = 'https://www.gdkjb.com/special/dasaiindex.html'
      }
    }
  }
</script>

<style lang="stylus">
// .adv {
//   animation: firstdiv 5s linear 1s infinite alternate;
// }
// @keyframes firstdiv{
//   0%{bottom:90px;right:20px;}
//   25%{bottom:90px;right:120px;}
//   50%{bottom:200px;right:120px;}
//   75%{bottom:200px;right:20px;}
//   100%{bottom:90px;right:20px;}
// }
</style>